// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"203":"30abbdf9902a7b25","894":"a3e464db6f546bfd"}[chunkId] + ".js";
};